var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 101,
    viewBox: "0 0 102 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4769 18.5174C46.5166 9.68313 54.1153 20.664 69.3129 37.0116C84.5105 53.3591 92.3396 54.5151 82.8986 74.3302C73.4577 94.1453 22.5688 88.3658 17.8867 71.9358C13.2047 55.5058 12.4371 27.3517 29.4769 18.5174Z",
    fill: "#F0E3CA",
    fillOpacity: 0.76
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3782 13.3264C80.8468 21.2793 76.898 34.0358 73.4176 56.0833C69.9372 78.1309 73.8605 85.0039 52.4433 89.8076C31.0261 94.6113 4.16082 51.007 14.1971 37.1816C24.2333 23.3562 45.9097 5.37351 63.3782 13.3264Z",
    fill: "#FF8303",
    fillOpacity: 0.82
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.0c7f7a6d19e334d200c6756709808317.svg";
export { ForwardRef as ReactComponent };